import { render } from "./StackedPlotItem.vue?vue&type=template&id=d0b88284"
import script from "./StackedPlotItem.vue?vue&type=script&lang=js"
export * from "./StackedPlotItem.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__